module.exports = __webpack_public_path__ + "resources\\localization\\it-it.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/it-it.json
 ** module id = 32
 ** module chunks = 0
 **/